import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Launch = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Launch' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M7,9 L7,14 C7,14 4,16 4,19 L4,20 L8,20 L10,23 L14,23 L16,20 L20,20 L20,19 C20,16 17,14 17,14 L17,9 C17,5 14,1 12,1 C10,1 7,5 7,9 Z M8,20 L16,20 M12,9 C12.5522847,9 13,8.55228475 13,8 C13,7.44771525 12.5522847,7 12,7 C11.4477153,7 11,7.44771525 11,8 C11,8.55228475 11.4477153,9 12,9 Z' />
  </StyledIcon>
);
